import { render, staticRenderFns } from "./TransFinListDetail.vue?vue&type=template&id=148d8c2d&scoped=true&"
import script from "./TransFinListDetail.vue?vue&type=script&lang=js&"
export * from "./TransFinListDetail.vue?vue&type=script&lang=js&"
import style0 from "./TransFinListDetail.vue?vue&type=style&index=0&id=148d8c2d&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148d8c2d",
  null
  
)

export default component.exports